/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const graph_decrease_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23.25 23.25h-1.5m-21 0h1.5M4.5.75l16.068 7.297m0 0-1.194-3.18m1.194 3.18-3.181 1.194M2.25 23.25V10.5A.75.75 0 0 1 3 9.75h3a.75.75 0 0 1 .75.75v12.75m-4.5 0h4.5m0 0h3m0 0V13.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v9.75m-4.5 0h4.5m0 0h3m0 0V18a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v5.25m-4.5 0h4.5"
    />
  </svg>
)
export default graph_decrease_medium
